// extracted by mini-css-extract-plugin
export default {"container":"CheckboxList_container__iNcYF"};